import { ExternalIds, IAutomationObject } from "./types";

export function getBimId(app: IAutomationObject | undefined) : string | undefined {
    return app ? (app.externalIds ? app.externalIds[ExternalIds[ExternalIds.BIM]] : undefined) : undefined;
}

export function getPlantId(app: IAutomationObject | undefined) : string | undefined {
    return app ? (app.externalIds ? app.externalIds[ExternalIds[ExternalIds.PlantIdentification]] : undefined) : undefined;
}